import { ChakraProvider } from '@chakra-ui/react';
import ErrorFallback from '@components/ErrorFallback';
import { defaultTheme } from '@config/theming';
import { CheckoutConfigProvider } from '@contexts/CheckoutConfig';
import CheckoutConfigLoader from '@FormRouter';
import resources from '@locales/resources';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import ReactDOM from 'react-dom/client';
import { ErrorBoundary } from 'react-error-boundary';
import { initReactI18next } from 'react-i18next';
import { QueryClient, QueryClientProvider } from 'react-query';
import { init, BrowserTracing, reactRouterV6Instrumentation } from '@sentry/react';
import React from 'react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    detection: {
      order: ['localStorage', 'navigator'],
    },
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

if (import.meta.env.RA_BUGSINK_DNS) {
  init({
    dsn: import.meta.env.RA_BUGSINK_DNS,
    release: import.meta.env.RA_COMMIT_HASH || 'devmode',
    environment: location.hostname,
    integrations: [
      new BrowserTracing({
        routingInstrumentation: reactRouterV6Instrumentation(
          React.useEffect,
          useLocation,
          useNavigationType,
          createRoutesFromChildren,
          matchRoutes,
        ),
      }),
    ],
    tracesSampleRate: 0,
  });
}

const root = ReactDOM.createRoot(document.getElementById('root')!);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

window.originHref = window.location.href;

root.render(
  <ErrorBoundary
    FallbackComponent={ErrorFallback}
    onReset={() => (window.location.href = location.href)}
  >
    <ChakraProvider theme={defaultTheme}>
      <QueryClientProvider client={queryClient}>
        <CheckoutConfigProvider>
          <ErrorBoundary
            FallbackComponent={ErrorFallback}
            onReset={() => (window.location.href = location.href)}
          >
            <CheckoutConfigLoader />
          </ErrorBoundary>
        </CheckoutConfigProvider>
      </QueryClientProvider>
    </ChakraProvider>
  </ErrorBoundary>,
);
